import { useState } from 'react';
import AlgorithmModal from './AlgorithmModal';

export default function TruthReport() {
  const [showAlgorithmModal, setShowAlgorithmModal] = useState(false);

  return (
    <>
      <section id="truth-report" className="py-24 bg-gradient-to-br from-green-50 via-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            {/* Left Side - Truth Meter Visual */}
            <div className="order-2 md:order-1">
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 p-8">
                <div className="text-center mb-8">
                  <h3 className="text-3xl font-bold text-gray-900 mb-2">Truth Meter</h3>
                  <p className="text-sm text-gray-600">Instant Reliability Rating</p>
                </div>

                {/* Apple Ratings */}
                <div className="space-y-6">
                  {/* Green Apple */}
                  <div className="flex items-start gap-4 bg-gradient-to-r from-green-50 to-green-100 rounded-xl p-6 border-2 border-green-500">
                    <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center">
                      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M28 8C28 8 30 4 28 2C26 4 28 8 28 8Z" fill="#10B981"/>
                        <ellipse cx="28" cy="6" rx="2" ry="1" fill="#10B981"/>
                        <path d="M28 12C18 12 10 20 10 30C10 40 18 48 28 48C38 48 46 40 46 30C46 20 38 12 28 12Z" fill="#22C55E"/>
                        <path d="M28 12C18 12 10 20 10 30C10 40 18 48 28 48C38 48 46 40 46 30C46 20 38 12 28 12Z" fill="url(#greenGradient)"/>
                        <ellipse cx="22" cy="24" rx="4" ry="5" fill="white" opacity="0.3"/>
                        <defs>
                          <linearGradient id="greenGradient" x1="10" y1="12" x2="46" y2="48" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#22C55E"/>
                            <stop offset="1" stopColor="#16A34A"/>
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-green-700 mb-2">Green Apple — Verified Truth</h4>
                      <p className="text-sm text-gray-700 leading-relaxed">
                        Supported by strong evidence, credible sources, and consistent reporting across reputable outlets.
                      </p>
                      <div className="mt-3 text-xs font-semibold text-green-600">Score: 70-100</div>
                    </div>
                  </div>

                  {/* Grey Apple */}
                  <div className="flex items-start gap-4 bg-gradient-to-r from-green-50 to-green-100 rounded-xl p-6 border-2 border-green-400">
                    <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center">
                      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M28 8C28 8 30 4 28 2C26 4 28 8 28 8Z" fill="#6B7280"/>
                        <ellipse cx="28" cy="6" rx="2" ry="1" fill="#6B7280"/>
                        <path d="M28 12C18 12 10 20 10 30C10 40 18 48 28 48C38 48 46 40 46 30C46 20 38 12 28 12Z" fill="#9CA3AF"/>
                        <path d="M28 12C18 12 10 20 10 30C10 40 18 48 28 48C38 48 46 40 46 30C46 20 38 12 28 12Z" fill="url(#greyGradient)"/>
                        <ellipse cx="22" cy="24" rx="4" ry="5" fill="white" opacity="0.3"/>
                        <defs>
                          <linearGradient id="greyGradient" x1="10" y1="12" x2="46" y2="48" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#9CA3AF"/>
                            <stop offset="1" stopColor="#6B7280"/>
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-green-700 mb-2">Grey Apple — Needs Verification</h4>
                      <p className="text-sm text-gray-700 leading-relaxed">
                        Contains partially supported, unclear, or inconsistently sourced claims. May be true but requires more verification.
                      </p>
                      <div className="mt-3 text-xs font-semibold text-green-600">Score: 40-69</div>
                    </div>
                  </div>

                  {/* Red Apple */}
                  <div className="flex items-start gap-4 bg-gradient-to-r from-green-50 to-green-100 rounded-xl p-6 border-2 border-green-600">
                    <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center">
                      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M28 8C28 8 30 4 28 2C26 4 28 8 28 8Z" fill="#7C2D12"/>
                        <ellipse cx="28" cy="6" rx="2" ry="1" fill="#7C2D12"/>
                        <path d="M28 12C18 12 10 20 10 30C10 40 18 48 28 48C38 48 46 40 46 30C46 20 38 12 28 12Z" fill="#DC2626"/>
                        <path d="M28 12C18 12 10 20 10 30C10 40 18 48 28 48C38 48 46 40 46 30C46 20 38 12 28 12Z" fill="url(#redGradient)"/>
                        <ellipse cx="22" cy="24" rx="4" ry="5" fill="white" opacity="0.3"/>
                        <defs>
                          <linearGradient id="redGradient" x1="10" y1="12" x2="46" y2="48" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#EF4444"/>
                            <stop offset="1" stopColor="#DC2626"/>
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-green-700 mb-2">Red Apple — Extreme or Untrue</h4>
                      <p className="text-sm text-gray-700 leading-relaxed">
                        Indicates misinformation, exaggeration, or unsupported claims with poor sourcing or misleading narratives.
                      </p>
                      <div className="mt-3 text-xs font-semibold text-green-600">Score: 0-39</div>
                    </div>
                  </div>
                </div>

                {/* Algorithm Button */}
                <button
                  onClick={() => setShowAlgorithmModal(true)}
                  className="mt-8 w-full flex items-center justify-center gap-3 px-6 py-4 bg-gray-900 text-white font-semibold rounded-xl hover:bg-gray-800 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-settings-3-line text-xl"></i>
                  <span>View Apple Truth Meter Calculator Details</span>
                </button>
              </div>
            </div>

            {/* Right Side - Truth Report Feature */}
            <div className="order-1 md:order-2">
              <div className="inline-block px-4 py-2 bg-green-100 text-green-700 text-sm font-semibold rounded-full mb-6 whitespace-nowrap">
                Truth Report Feature
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Finding Truth in <span className="text-green-600 whitespace-nowrap">The Middle</span>
              </h2>
              <p className="hidden md:block text-lg text-gray-700 mb-6 leading-relaxed">
                Our innovative <strong className="text-gray-900">Truth Report Feature</strong> compares two extremes to uncover the truth. By analyzing opposing perspectives and fact-checking claims from all sides, we deliver balanced, objective reporting.
              </p>
              <p className="md:hidden text-base text-gray-700 mb-6 leading-relaxed">
                Compare extremes to uncover truth through balanced, objective reporting.
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-4 bg-gray-50 rounded-xl p-6">
                  <div className="flex-shrink-0 w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                    <i className="ri-scales-3-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Balanced Analysis</h3>
                    <p className="hidden md:block text-sm text-gray-600 leading-relaxed">We examine both sides of every story, identifying biases and presenting facts objectively.</p>
                    <p className="md:hidden text-sm text-gray-600 leading-relaxed">Examine both sides objectively.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 bg-gray-50 rounded-xl p-6">
                  <div className="flex-shrink-0 w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                    <i className="ri-shield-check-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Fact Verification</h3>
                    <p className="hidden md:block text-sm text-gray-600 leading-relaxed">Every claim is verified through multiple sources and cross-referenced for accuracy.</p>
                    <p className="md:hidden text-sm text-gray-600 leading-relaxed">Verify through multiple sources.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 bg-gray-50 rounded-xl p-6">
                  <div className="flex-shrink-0 w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                    <i className="ri-lightbulb-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Truth Discovery</h3>
                    <p className="hidden md:block text-sm text-gray-600 leading-relaxed">By comparing extremes, we reveal the nuanced truth that lies between polarized narratives.</p>
                    <p className="md:hidden text-sm text-gray-600 leading-relaxed">Reveal truth between extremes.</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-2xl p-8 text-white">
                <div className="flex items-center gap-4 mb-4">
                  <i className="ri-information-line text-3xl"></i>
                  <h3 className="text-xl font-bold">How It Works</h3>
                </div>
                <p className="hidden md:block text-base leading-relaxed opacity-95">
                  Our Truth Report analyzes opposing viewpoints, identifies common ground, fact-checks all claims, and presents a comprehensive, unbiased report that helps readers understand the complete picture.
                </p>
                <p className="md:hidden text-sm leading-relaxed opacity-95">
                  Analyze viewpoints, fact-check claims, present unbiased reports.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AlgorithmModal 
        isOpen={showAlgorithmModal} 
        onClose={() => setShowAlgorithmModal(false)} 
      />
    </>
  );
}
